import styled from '@eduzz/houston-styles';

interface IContainerProps {
  position: 'left' | 'right';
}

export const Container = styled.div<IContainerProps>`
  width: 12.5rem;
  background-color: #fff;
  border-radius: ${({ theme }) => theme.spacing.quarck};
  padding: ${({ theme }) => theme.spacing.nano};
  z-index: 1;
  position: absolute;
  ${({ position }) => (position === 'left' ? 'left: 26px' : 'right: 10px')};
  margin-top: ${({ position }) => (position === 'left' ? '28px' : '0')};
  box-shadow: 5px 6px 10px rgba(0, 0, 0, 0.25);

  && ::after {
    content: '';
    position: absolute;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #fff transparent;
    bottom: 100%;
    left: ${({ position }) => (position === 'left' ? '50%' : '90%')};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.neutralColor.low.dark};
  margin-bottom: ${({ theme }) => theme.spacing.nano};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Item = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  padding: 8px 2px;

  &:hover {
    background-color: #eeee;
    transition: all 0.3s ease 0s;
    cursor: pointer;
  }
  img {
    max-width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  span {
    overflow: hidden;
    white-space: nowrap;
    color: ${({ theme }) => theme.neutralColor.low.pure};
    width: 100%;
    text-overflow: ellipsis;
  }
`;
